import React, { useState } from "react";
import { motion } from "framer-motion";
import Heading from "../Typography/Heading";
import InteractiveText from "../Typography/InteractiveText";
import {
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../../../sections/Public/shared/publicLayoutSpec";

const BusinessSupportFAQs = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const faqs = [
    {
      question: "What is Trades Poster Business Support?",
      answer:
        "Trades Poster Business Support provides tools, resources, and guidance to help businesses grow, connect with customers, and manage their online presence effectively.",
    },
    {
      question: "How can I showcase my business portfolio?",
      answer:
        "You can easily upload images, add descriptions, and highlight your best work in the Business Portfolio section. This helps potential customers see your expertise and completed projects.",
    },
    {
      question: "Is there messaging support for businesses?",
      answer:
        "Yes, our integrated messaging system allows you to communicate directly with customers, respond to inquiries, and manage conversations all in one place.",
    },
    {
      question: "Can I get help with setting up my business profile?",
      answer:
        "Absolutely! Our Help & Support section offers step-by-step guides, FAQs, and direct support to assist you in setting up and optimizing your business profile.",
    },
    // {
    //   question: "Are there resources for improving my business visibility?",
    //   answer:
    //     "Yes, we provide tips, best practices, and promotional tools to help your business stand out and attract more customers on Trades Poster.",
    // },
  ];

  const toggleHandler = (index) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };

  return (
    <div id="business-faqs" className={`tp-container-narrow mx-auto ${PUBLIC_SECTION_GAP_CLASS}`}>
      <motion.div 
        className="w-full"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={staggerContainer}
      >
        <motion.div variants={fadeInUp} transition={{ duration: 0.6, ease: "easeOut" }}>
          <Heading variant={"h2"} className={"text-offblack"}>
            Business FAQs
          </Heading>
        </motion.div>
        
        <motion.div
          className={PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}
          variants={fadeInUp}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="border-t border-solid border-mediumgray"></div>
        </motion.div>

        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="border-b border-solid border-mediumgray"
              variants={fadeInUp}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <div
                className="flex items-center justify-between py-6 px-4 cursor-pointer transition-colors duration-200"
                onClick={() => toggleHandler(index)}
              >
                <InteractiveText variant={"FAQHeader"} className="text-offblack font-medium">
                  {faq.question}
                </InteractiveText>
                <i
                  className={`fi ${
                    activeIndex === index ? "fi-rs-angle-up" : "fi-rs-angle-down"
                  } text-base text-offblack transition-transform duration-300 ease-in-out`}
                />
              </div>
              
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  activeIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="pb-6 px-4">
                  <InteractiveText variant={"FAQAnswer"} className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </InteractiveText>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default BusinessSupportFAQs; 